import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BrowserService } from '../../../../domains/browser.service';

@Component({
  selector: 'gc-qr-code-modal',
  templateUrl: './qr-code-modal.component.html',
  styleUrls: ['./qr-code-modal.component.scss'],
})
export class QrCodeModalComponent {
  @Input() profileUrl!: string;
  @ViewChild('qrCodeWrapper', { static: false }) qrCodeWrapper!: ElementRef<HTMLDivElement>;

  constructor(
    public modalGC: ModalController,
    private browser: BrowserService,
  ) {}

  async downloadQRCode() {
    try {
      // Wait for view update
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Get QR code image element
      const wrapper = this.qrCodeWrapper?.nativeElement;
      if (!wrapper) {
        console.error('Unable to find QR code container');
        return;
      }

      const img = wrapper.querySelector('img');
      if (!img) {
        console.error('Unable to find QR code image element');
        return;
      }

      // Create a canvas to download the image
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      if (!ctx) {
        console.error('Unable to create canvas context');
        return;
      }

      // Wait for image to load
      await new Promise((resolve, reject) => {
        if (img.complete) {
          resolve(null);
        } else {
          img.onload = () => resolve(null);
          img.onerror = reject;
        }
      });

      canvas.width = img.naturalWidth || img.width;
      canvas.height = img.naturalHeight || img.height;
      
      ctx.drawImage(img, 0, 0);
      
      // Convert canvas to blob and download
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error('Unable to create blob');
          return;
        }

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'installer-profile-qrcode.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 'image/png');
    } catch (error) {
      console.error('Error downloading QR code:', error);
    }
  }

  async openLink() {
    await this.browser.openUrl(this.profileUrl);
  }
}

